import { Box } from '@mui/material'
import { styled as muiStyled } from '@mui/system'
import styled from '@emotion/styled/macro'
import theme from 'theme'

export const SearchVendorsContainer = styled(Box)`
  display: flex;
  flex-flow: row nowrap;
  align-items: flex-end;
  gap: ${theme.spacing.small}px;
  width: 100%;
  margin-top: 18px;
  z-index: 100000000;

  .search-icon-wrapper {
    display: flex;
    width: 48px;
    height: 48px;
    padding: 8px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 10px;
    border-radius: 12px;
    background: #ffa9fc;

    &:hover {
      background: ${theme.baseColors.primary[70]};
      color: ${theme.baseColors.primary[20]};

      svg {
        path {
          stroke: ${theme.baseColors.primary[20]};
        }
      }
    }

    &:focus,
    &:active {
      background: #483646;

      svg {
        path {
          stroke: ${theme.colors.cta};
        }
      }
    }
  }
`

export const AutocompleteContainer = muiStyled('div')`
  position: relative;
  width: 100%;
`

export const SearchVendorsInputWrapper = styled(Box)`
  width: 100%;
  gap: 2px;
  display: flex;
  flex-flow: column wrap;

  .form-label-wrapper {
    .form-label-text {
      overflow: hidden;
      color: ${theme.colors.foreground};
      text-overflow: ellipsis;
      font-family: ${theme.typography.fontFamily.primary};
      font-size: ${theme.typography.fontSize.xLarge};
      font-style: normal;
      font-weight: ${theme.typography.fontWeight.normal};
      line-height: normal;
    }
  }

  & .MuiFormControl-root {
    width: 100%;
    border: none;
    outline: 0;
    height: 48px;

    .MuiInputLabel-root {
      color: ${theme.colors.dropdownLabel} !important;
      font-family: Quicksand, sans-serif !important;
      font-size: 12px !important;
      font-style: normal !important;
      font-weight: 500 !important;
    }

    & .MuiOutlinedInput-root {
      border: 0;
      letter-spacing: 0.5px;
      height: 48px;
      color: ${theme.colors.menuItemText};
      font-family: Quicksand, sans-serif;
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: 20px;

      &:-webkit-autofill {
        -webkit-background-clip: text !important;
        -webkit-text-fill-color: ${theme.colors.devicesSecondaryText};
        opacity: 1;
      }

      & .MuiOutlinedInput-input {
        border: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        color: ${theme.colors.menuItemText};
        font-family: Quicksand, sans-serif;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 20px;

        &::placeholder {
          color: ${theme.colors.devicesSecondaryText};
          font-family: Quicksand, sans-serif;
          font-size: 14px;
          font-style: normal;
          font-weight: 500;
          line-height: 20px;
          opacity: 1;
        }
      }

      & .end-adornment-close-icon {
        color: ${theme.colors.foreground};
        padding: ${theme.spacing.half}px;
        margin-right: ${theme.spacing.half}px;

        &:hover {
          background: rgba(255, 255, 255, 0.05);
        }
      }

      fieldset {
        border: 1px solid ${theme.colors.dropdownBorder};
        border-radius: 12px;
        color: ${theme.colors.dropdownLabel};
        font-family: Quicksand, sans-serif;
        font-size: 12px;
        font-style: normal;
        font-weight: 500;
        line-height: 12px;
      }

      &:hover fieldset {
        border-color: ${theme.colors.cta};
      }

      &.Mui-focused {
        border: none;

        & fieldset {
          border: 2px solid ${theme.colors.cta};
        }
      }
    }

    & .search-vendors-loading-indicator {
      color: ${theme.colors.cta};
    }
  }
`

export const ResultListItem = styled('li')<{ iscustomvendor?: string }>`
  display: flex;
  align-items: center;
  padding: ${theme.spacing.md}px;
  cursor: default;
  list-style: none;

  .option-text {
    color: ${theme.colors.foreground};
    font-family: ${theme.typography.fontFamily.primary};
    font-size: ${theme.typography.fontSize.xLarge};
    font-style: normal;
    font-weight: ${theme.typography.fontWeight.normal};
    line-height: 24px;
    letter-spacing: 0.5px;
    flex-grow: 1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 300px;
  }

  &:hover {
    cursor: pointer;
    background: rgba(208, 188, 255, 0.08);
  }

  &[aria-selected='true'] {
    background: rgba(208, 188, 255, 0.08);
  }

  &.Mui-focused,
  &.Mui-focusVisible {
    background: rgba(208, 188, 255, 0.08);
  }

  &[aria-selected='true'].Mui-focused,
  &[aria-selected='true'].Mui-focusVisible {
    background: rgba(208, 188, 255, 0.08);
  }

  html[data-theme='light'] & {
    &:hover {
      background: ${theme.colors.menuItemHover} !important;
    }

    &[aria-selected='true'],
    &.Mui-focused,
    &.Mui-focusVisible {
      background: ${theme.colors.cardFillTertiary} !important;
    }
  }

  ${({ iscustomvendor }) =>
    iscustomvendor &&
    iscustomvendor === 'true' &&
    `    
      &:hover {
        cursor: pointer;
        background: rgba(208, 188, 255, 0.08) !important;  
  
        &:last-of-type {
          box-shadow: none;
          background: transparent;
        }
      }
    
      &:last-of-type {
        background: transparent;
        
        &:hover {
          background: rgba(208, 188, 255, 0.08) !important;
        }
      }
    `}

  .vendor-logo-icon {
    margin-right: ${theme.spacing.small}px;
    width: 24px;
    height: 24px;
    object-fit: cover;
    object-position: center;
  }

  .add-custom-loading-wrapper {
    color: ${theme.colors.cta};
  }
`

export const ResultsList = styled('ul')<{ hideborder?: string; length: number }>`
  font-family: ${theme.typography.fontFamily.primary};
  font-size: 0.875rem;
  box-sizing: border-box;
  padding: 0;
  margin: 0;
  outline: 0;
  background: ${theme.colors.borderLow};
  border-radius: ${theme.attributes.borderRadius.secondary};

  html[data-theme='light'] & {
    background: ${theme.colors.surfaceContainerBackground};
  }
  max-height: 250px;

  ${({ hideborder }) =>
    hideborder &&
    hideborder === 'true' &&
    `
      border-radius: 0 0 ${theme.attributes.borderRadius.secondary} ${theme.attributes.borderRadius.secondary};
  `};

  ${({ length }) =>
    length > 5 &&
    `
    overflow-y: scroll;
  `};

  ::-webkit-scrollbar {
    width: 4px;
    background: ${theme.colors.controlBorder};
    border-radius: ${theme.attributes.borderRadius.secondary};
  }

  ::-webkit-scrollbar-track {
    box-shadow: none;
    background: transparent;
  }

  ::-webkit-scrollbar-thumb {
    background-color: ${theme.colors.cta};
    border-radius: ${theme.attributes.borderRadius.secondary};
    html[data-theme='light'] & {
      background-color: ${theme.colors.borderMedium};
    }
  }
`

export const SearchVendorsResultsContainer = styled('div')`
  border-radius: ${theme.attributes.borderRadius.secondary};
  background: ${theme.colors.borderLow};

  html[data-theme='light'] & {
    background: ${theme.colors.surfaceContainerBackground};
  }
  box-shadow: ${theme.attributes.boxShadow.chipCircle};
  z-index: 1;
  position: absolute;
  left: 0;
  right: 0;
  margin-top: ${theme.spacing.xSmall}px;

  .search-vendors-results-text {
    color: ${theme.colors.devicesSecondaryText};
    font-family: ${theme.typography.fontFamily.primary};
    font-size: ${theme.typography.fontSize.mediumSmall};
    font-style: normal;
    font-weight: ${theme.typography.fontWeight.bold};
    line-height: 16px;
    letter-spacing: 0.5px;
    margin: ${theme.spacing.xSmall}px 0 0 ${theme.spacing.md}px;
  }

  .search-vendors-loading-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    min-height: 260px;

    .search-vendors-loading-progress {
      color: ${theme.colors.cta};
    }
  }

  .search-vendors-empty-wrapper {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    flex-direction: column;
    gap: ${theme.spacing.half}px;
    padding: 39px ${theme.spacing.small}px ${theme.spacing.small}px ${theme.spacing.small}px;

    .search-vendors-empty-title {
      color: ${theme.colors.foreground};
      font-family: ${theme.typography.fontFamily.primary};
      font-size: ${theme.typography.fontSize.xLarge};
      font-style: normal;
      font-weight: ${theme.typography.fontWeight.bold};
      line-height: 24px;
      letter-spacing: 0.1px;
    }

    .search-vendors-empty-text {
      color: ${theme.colors.foreground};
      font-family: ${theme.typography.fontFamily.primary};
      font-size: ${theme.typography.fontSize.large};
      font-style: normal;
      font-weight: ${theme.typography.fontWeight.normal};
      line-height: 20px;
      letter-spacing: 0.25px;
    }
  }
`
